<template>
  <a class="btn-link" :href="href" :target="target"><slot></slot></a>
</template>

<script>
export default {
  name: 'IpsLink',
  props: {
    href: {
      name: 'href',
      description: 'The link address',
      type: String,
      default: '',
      required: false,
    },
    target: {
      name: 'target',
      description: 'The target of the link',
      type: String,
      default: '_self',
      required: false,
      validator(value) {
        return ['', '_blank', '_self', '_parent', '_top'].indexOf(value) !== -1;
      },
    },
  },
};
</script>
